// File: useCustomerFilter.ts
import { useCustomerFilterContext } from '../contexts/CustomerFilterContext';

interface CustomerFilter {
  customerId: string | null;
  customerName: string | null;
  isFiltered: boolean;
}

export const useCustomerFilter = (): CustomerFilter => {
  // Use context instead of URL parameters for security
  const { customerId, customerName, isFiltered } = useCustomerFilterContext();
  
  return {
    customerId,
    customerName,
    isFiltered
  };
};